import { trackEvent } from '@/omega/index.js';

/**
 * 背景：异常类型，前端异常、接口异常
 * 目标：快速排除接口异常导致的问题
 * 核心链路：用户手机号 -> uid -> traceId
 */
export const apiErrorLogs = (result = {}, path = '') => {
  try {
    const { errno, requestId, time, traceId } = result || {};

    if (traceId) {
      trackEvent({
        eventId: 'sailing_c_entrega_tech_api_error_bt',
        eventLabel: 'B2C接口请求异常',
        attrs: {
          request_path: path,
          request_errno: errno,
          request_time: time,
          request_id: requestId,
          trace_id: traceId,
        },
      });
    }
  } catch (err) {
    console.log(err);
  }
};


/** @desc 项目API请求监控埋点 */
export const apiMonitorLog = (response) => {
  try {
    if (response && +response.status === 200) {
      const { config, data } = response
      const { errno, traceId = '', trace_id = '', requestId = '', time = '' } = data

      trackEvent({
        eventId: 'sailing_c_api_monitor_bt',
        eventLabel: 'api请求上报',
        attrs: {
          request_errno: errno,
          request_path: config.url,
          trace_id: traceId || trace_id,
          page_url: window.location.href,
          request_id: requestId,
          request_time: time
        }
      })
    }
  } catch (err) {
    console.log(err)
  }
}
